import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><code parentName="td" {...{
              "className": "language-text"
            }}>{`data`}</code></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An object containing the result of your GraphQL subscription. Defaults to an empty object.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><code parentName="td" {...{
              "className": "language-text"
            }}>{`loading`}</code></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A boolean that indicates whether any initial data has been returned`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><code parentName="td" {...{
              "className": "language-text"
            }}>{`error`}</code></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ApolloError`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A runtime error with `}<code parentName="td" {...{
              "className": "language-text"
            }}>{`graphQLErrors`}</code>{` and `}<code parentName="td" {...{
              "className": "language-text"
            }}>{`networkError`}</code>{` properties`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      